import React from "react";
import { Modal, Button } from "react-bootstrap";

function ContactProviderModal(props) {
  return (
    <div>
      <Modal
        show={props.show}
        onHide={props.handleShow}
      >
        <Modal.Header closeButton>
          <Modal.Title className="text-primary">Contact Provider</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <h4>Contact {props.provider.provider_name}</h4>
          <p>
            You may contact your provider by calling:{" "}
            {props.provider.provider_number}
          </p>
          <p>
            You may contact your provider by emailing:{" "}
            {props.provider.provider_email}
          </p>
          <br />
          <p>
            For more information you can visit:
            <a target="_blank" href={props.provider.provider_site}>
              {props.provider.provider_site}
            </a>
          </p>
        </Modal.Body>
        <Modal.Footer>
          <Button
            className="btn btn-warning"
            onClick={props.handleShow}
          >
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
}

export default ContactProviderModal;



// WEBPACK FOOTER //
// ./src/home/components/contact-provider-modal.js